import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

const labels = { it: "Italiano", en: "English", fr: "Français", de: "Deutsch" };
const flags  = { it: "🇮🇹", en: "🇬🇧", fr: "🇫🇷", de: "🇩🇪" };

export default function LanguageSwitcher({ light = false }) {
  const { lang, setLang, languages } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className={`flex items-center gap-2 text-sm px-2.5 py-1.5 rounded-sm border ${
          light ? "border-white/20 text-white/90 hover:bg-white/10" : "border-border text-foreground hover:bg-accent"
        } transition-colors`}
      >
        <Globe className="w-4 h-4" />
        <span className="font-medium">{flags[lang]} {lang.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`language-switcher-item-${l}`}
            onClick={() => setLang(l)}
            className={lang === l ? "bg-accent" : ""}
          >
            <span className="mr-2">{flags[l]}</span> {labels[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
